import React from 'react';
import Link from '@mui/material/Link';
var createAbsoluteExternalLink = function (urlValue) {
    if (!urlValue || urlValue.startsWith('http://') || urlValue.startsWith('https://')) {
        return urlValue;
    }
    return 'https://' + urlValue;
};
var LinkDecorator = function (_a) {
    var children = _a.children, contentState = _a.contentState, entityKey = _a.entityKey;
    var url = contentState.getEntity(entityKey).getData().url;
    var absoluteUrl = createAbsoluteExternalLink(url);
    var handleOnClickLink = function (event) {
        event.stopPropagation();
    };
    return (React.createElement("span", { onClick: handleOnClickLink },
        React.createElement(Link, { href: absoluteUrl, target: "_blank" }, children)));
};
export default LinkDecorator;
//# sourceMappingURL=LinkDecorator.js.map